const FindPosition = (box, setState, distance = 400) => {
  const elem = box.getBoundingClientRect();
  const heightCont = window.innerHeight;
  setState(heightCont - elem.top < distance);
};

export default FindPosition;
